import { render, staticRenderFns } from "./WhitepaperForm.vue?vue&type=template&id=0c390419&scoped=true"
import script from "./WhitepaperForm.vue?vue&type=script&lang=js"
export * from "./WhitepaperForm.vue?vue&type=script&lang=js"
import style0 from "./WhitepaperForm.vue?vue&type=style&index=0&id=0c390419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c390419",
  null
  
)

export default component.exports